import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';

const NotFound = () => {
    return (
        <div className="flex flex-col items-center justify-center h-screen gap-2">
            <Helmet>
                <title>Not found - Active Projects</title>
                <meta name="robots" content="noindex, follow" />
            </Helmet>
            <h1 className="text-4xl font-bold">404</h1>
            <h2 className="text-2xl">Page not found</h2>
            <Link to="/feed" className="btn btn-primary mt-4">
                Browse builds
            </Link>
        </div>
    );
}

export default NotFound;
